import { Link } from "react-router-dom";

export function EnAbout() {
  return (
    <>
     <p className="fs-5">
      *Pro*TankiRating is a fork of <a href="https://tankirating.org">TankiRating</a>.<br />
       At the moment, registration on the hub is open
     </p>    
     <p className="fs-5">
      The main purpose of this hub is the ability to view game statistics "in dynamic". 
      As opposed to <a href="https://pro-tanki.online/en/ratings">the official rating site</a>, you can view the 
      user's gaming activity and effictiveness on the time intervals, as well as compare 
      activity/effictiveness over time on charts
       <br/>
     </p>
     <p className="fs-5">
      Just open <Link to="/">the main page</Link>, and enjoy!
     </p>
 
     <p className="h3 mt-4">
       The Hub
     </p>
 
     <ul className="ms-4">
       <li><span className="fs-5"><Link to="/">Main page</Link> — User ratings</span></li>
       <li><span className="fs-5"><Link to="/user/Fizzika">The user profile</Link> — Player statistics</span></li>
       <li><span className="fs-5"><Link to="/trends">Trends</Link> — Summary statistics of all legend-players</span></li>
       {/* <li><span className="fs-5"><Link to="/online">OnlineHub</Link> — The Great Online Chart (only archive data, thanks to alternativa games)</span></li> */}
     </ul>
 
     {/* <p className="h3 mt-4">
       <a name="contact">Contacts</a>
     </p>
     <p className="fs-5">
      If you changed your nickname, want to delete/freeze your account on the portal, or just have something to say:     </p>
     <ul className="ms-4">
        <li><span className="fs-5">Discord <b>pngdrift</b></span></li>
     </ul> */}

    </>
   )
}